/**
 * Context requirements for API endpoints
 * Defines which headers are required for different operations
 */
export var ContextRequirement;
(function (ContextRequirement) {
    ContextRequirement["TENANT_ID"] = "TENANT_ID";
    ContextRequirement["DOMAIN_ID"] = "DOMAIN_ID";
    ContextRequirement["SUBJECT_ID"] = "SUBJECT_ID";
})(ContextRequirement || (ContextRequirement = {}));
export const CONTEXT_HEADERS = {
    [ContextRequirement.TENANT_ID]: 'x-tenant-id',
    [ContextRequirement.DOMAIN_ID]: 'x-domain-id',
    [ContextRequirement.SUBJECT_ID]: 'x-subject-id'
};
//# sourceMappingURL=contextRequirements.js.map